import { createFileRoute } from "@tanstack/react-router";
import { ApiInternal } from "src/api/api_internal";
import React from "react";
import Form from "src/components/base/form";
import { useTranslation } from "react-i18next";
import { Fieldset } from "@headlessui/react";
import { Description, Field, FieldGroup, Label } from "src/components/base/fieldset";
import { Input } from "src/components/base/input";
import { Subheading } from "src/components/base/heading";
import { BackButton } from "src/components/base/button";

/**
 * The properties for {@link OidcSettings}
 */
type OidcSettingsProps = {};

/**
 * The OIDC settings page
 */
function OidcSettings(props: OidcSettingsProps) {
    const [t] = useTranslation("admin-settings");

    const settings = Route.useLoaderData();

    return (
        <Form className={"flex max-w-lg flex-col gap-6"} onSubmit={() => {}}>
            <BackButton className={"self-start"} href={"/a/settings/oidc"}>
                {t("button.back-to-oidc-settings")}
            </BackButton>
            <Subheading>{t("heading.trufflepig-oidc")}</Subheading>
            <Fieldset className={"max-w-lg"}>
                <FieldGroup>
                    <Field>
                        <Label>{t("label.issuer-url")}</Label>
                        <Description>{t("description.issuer-url")}</Description>
                        <Input disabled={true} value={settings.internal_frontend.url} />
                    </Field>

                    <Field>
                        <Label>{t("label.client-id")}</Label>
                        <Description>{t("description.client-id")}</Description>
                        <Input disabled={true} value={settings.internal_frontend.client_id} />
                    </Field>

                    <Field>
                        <Label>{t("label.client-secret")}</Label>
                        <Description>{t("description.client-secret")}</Description>
                        <Input disabled={true} type={"password"} value={settings.internal_frontend.client_secret} />
                    </Field>

                    <Field>
                        <Label>{t("label.redirect-url")}</Label>
                        <Description>{t("description.redirect-url")}</Description>
                        <Input disabled={true} value={settings.internal_frontend.redirect_url} />
                    </Field>
                </FieldGroup>
            </Fieldset>
        </Form>
    );
}

export const Route = createFileRoute("/_admin/a/settings/_settings/oidc/trufflepig")({
    component: OidcSettings,
    loader: async () => await ApiInternal.settings.getOidc(),
});
